<template name="systemVariableList">
  <el-card v-if="ok">
    <div slot="header" class="clearfix info-title">
      <span>系统变量信息</span>
    </div>
    <div class="container2">
      <div style="display: flex;align-items: center;">
        <div class="info-title">
          <i class="el-icon-setting"/>
          系统时间：
        </div>
        <div class="info-content">{{ sysVariableList[0].curTime }}</div>
      </div>

      <hr style="margin-top: 10px;margin-bottom: 20px;"/>

      <div style="display: flex;align-items: center;">
      <div class="info-title">
        <i class="el-icon-setting"/>
        系统日期：
      </div>
      <div class="info-content">{{ sysVariableList[0].curDate }}</div>
      </div>
      <hr style="margin-top: 10px;margin-bottom: 20px;"/>

      <div style="display: flex;align-items: center;">
      <div class="info-title">
        <i class="el-icon-setting"/>
        系统年份：
      </div>
      <div class="info-content">{{ sysVariableList[0].curYear }}</div></div>

      <hr style="margin-top: 10px;margin-bottom: 20px;"/>

      <div style="display: flex;align-items: center;">
      <div class="info-title">
        <i class="el-icon-setting"/>
        系统月份：
      </div>
      <div class="info-content">{{ sysVariableList[0].curMonth }}</div>
      </div>
      <hr style="margin-top: 10px;margin-bottom: 20px;"/>
      <div style="display: flex;align-items: center;">
      <div class="info-title">
        <i class="el-icon-setting"/>
        系统日份：
      </div>
      <div class="info-content">{{ sysVariableList[0].curDay }}</div>
    </div>
    </div>
  </el-card>
</template>

<script>
import API from "@/../config/api.js";
let self;
export default {
  name: "systemVariableList",
  data() {
    return {
      sysVariableList: [],
      userId: '',
      customStyle: {
        color: '#3399ff',
      },
      customStyle3: {
        color: '#55aa00',
      },
      customStyle4: {
        color: '#aa55ff',
      },
      ok: false,
    }
  },
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  mounted: function () {
    this.userId = window.localStorage.getItem('userid');
    self = this;
    // 获取该公司全部的一级项目
    this.getSysVariableList();
  },
  methods: {
    // 获取当前公司所有的系统变量
    getSysVariableList() {
      console.log("获取公司一级项目")
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getSysVariableList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          self.sysVariableList = res.data["sysVariableList"]
          console.log(self.sysVariableList)
          self.ok = true;
        }
      });
    },
  },
}
</script>

<style>

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  font-weight: bold;
}

.info-content {
  margin: 10px 0px 10px 10px; /* 上 右 下 左 */
  height: auto;
}

.btn {
  margin-left: 80px;

}
</style>